var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#104145"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2242_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5818 13.0909C10.5818 12.4848 10.7939 11.9848 11.2181 11.5909C11.6424 11.197 12.1939 11 12.8727 11C13.5394 11 14.0787 11.1939 14.4909 11.5818C14.9151 11.9818 15.1272 12.503 15.1272 13.1455C15.1272 13.7273 14.9212 14.2121 14.5091 14.6C14.0848 15 13.5272 15.2 12.8363 15.2H12.8181C12.1515 15.2 11.6121 15 11.2 14.6C10.7878 14.2 10.5818 13.697 10.5818 13.0909ZM10.8182 29V16.8545H14.8545V29H10.8182ZM17.0909 29H21.1272V22.2182C21.1272 21.7939 21.1757 21.4666 21.2727 21.2363C21.4424 20.8242 21.7 20.4757 22.0454 20.1909C22.3909 19.906 22.8242 19.7636 23.3454 19.7636C24.703 19.7636 25.3818 20.6788 25.3818 22.5091V29H29.4181V22.0363C29.4181 20.2424 28.9939 18.8818 28.1454 17.9545C27.2969 17.0273 26.1757 16.5636 24.7818 16.5636C23.2181 16.5636 21.9999 17.2364 21.1272 18.5818V18.6182H21.109L21.1272 18.5818V16.8545H17.0909C17.1151 17.2424 17.1272 18.4485 17.1272 20.4727C17.1272 22.4969 17.1151 25.3394 17.0909 29Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2242_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8363,
    height: 18,
    fill: "white",
    transform: "translate(10.5818 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinNew);
export default __webpack_public_path__ + "static/media/linkedin-new.e30865f0913950251ebbe5417b73ad0c.svg";
export { ForwardRef as ReactComponent };